import { idSchema } from "@stylingcv/schema";
import { dateSchema } from "@stylingcv/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { secretsSchema } from "../secrets";

export const usernameSchema = z
  .string()
  .min(3)
  .max(255)
  .regex(/^[\w.-]+$/, {
    message: "Usernames can only contain letters, numbers, periods, hyphens, and underscores.",
  })
  .transform((value) => value.toLowerCase());

export const subscriptionTierSchema = z
  .enum(["FREE", "BASIC", "PROFESSIONAL", "ENTERPRISE"])
  .default("FREE");

export const userRoleSchema = z
  .enum(["USER", "ADMIN", "SUPER_ADMIN"])
  .default("USER");

export const userSchema = z.object({
  id: idSchema,
  name: z.string().min(1).max(255),
  picture: z.literal("").or(z.null()).or(z.string().url()),
  username: usernameSchema,
  email: z
    .string()
    .email()
    .transform((value) => value.toLowerCase()),
  locale: z.string().default("en-US"),
  emailVerified: z.boolean().default(false),
  twoFactorEnabled: z.boolean().default(false),
  emailLocked: z.boolean().default(true),
  role: userRoleSchema,
  subscriptionTier: subscriptionTierSchema,
  provider: z.enum(["email", "github", "google", "facebook", "apple", "openid", "linkedin"]).default("email"),
  aiTokensUsed: z.number().default(0),
  freePdfLastExportAt: z.date().nullable(),
  aiTokensResetDate: z.date().nullable(),
  hasLegacyResumes: z.boolean().default(false),
  legacyResumeCount: z.number().nullable().optional(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class UserDto extends createZodDto(userSchema) {}

export const userWithSecretsSchema = userSchema.merge(
  z.object({ secrets: secretsSchema.nullable().default(null) }),
);

export class UserWithSecrets extends createZodDto(userWithSecretsSchema) {}
